import { render, staticRenderFns } from "./DepartmentCode021.vue?vue&type=template&id=8ea97b64&scoped=true&"
import script from "./DepartmentCode021.vue?vue&type=script&lang=js&"
export * from "./DepartmentCode021.vue?vue&type=script&lang=js&"
import style0 from "./DepartmentCode021.vue?vue&type=style&index=0&id=8ea97b64&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ea97b64",
  null
  
)

export default component.exports